module.exports = __webpack_public_path__ + "static/media/300_01.7c45acf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/luckyclover/300_01.jpg
// module id = 668
// module chunks = 1